module.exports = __webpack_public_path__ + "img/betgamestv.08b90f36.svg";